<div class="container">
  <img src="imgs/thinking.png" class="logo-icon">
  <p>{{'login-callback.validating' | translate}}</p>
</div>
